<template>
    <div class="app-main">

        <div class="top-bar">
          <el-button type="success" plain style="width:120px" @click="showDialog(1)">添加品牌</el-button>
        </div>
        <el-card shadow="hover" style="width:1000px">
            <el-table ref="multipleTable" :data="tableData"  height="600">
                <el-table-column prop="name"      label="品牌名称" align="center" ></el-table-column>
                <el-table-column  align="center" label="编辑">
                    <template slot-scope="scope">
                        <el-button  @click="showDialog(2, scope.row)"  size="mini"  type="success" plain style="margin-right:15px">修改</el-button> 
                        <el-popconfirm @onConfirm="del(scope.row.id)" :title="`此操作将删除品牌：${scope.row.name}`">
                            <el-button slot="reference" size="mini" type="danger" plain>删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  background layout="prev, pager, next, jumper" :total="total" :page-size="size" @current-change="loadData" style="padding:15px 15px 15px 0"></el-pagination>
        </el-card>

        <el-dialog title="品牌编辑" :visible.sync="dialog" @closed="resetData" center class="dialog">
            <div class="dialog-content">
                
                <div style="width:50%">
                    <span>品牌名称：</span>
                    <el-input v-model="row.name"  style="width:65%;margin-top:15px;"></el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer" v-show="type == 1">
                <el-button @click="dialog = false" style="width:120px">取 消</el-button>
                <el-button type="primary" @click="add"  style="width:120px">添 加</el-button>
            </div>
            <div slot="footer" class="dialog-footer" v-show="type == 2">
                <el-button @click="dialog = false" style="width:120px">取 消</el-button>
                <el-button type="primary" @click="edit"  style="width:120px">修 改</el-button>
            </div>
        </el-dialog>

        
    </div>
</template>
<script>
import { brand_list, brand_add, brand_put, brand_del } from '@/api/goods.js'

export default {
    name:'goodsBrand',
    data () {
        return {
            tableData:[],
            total: 0,
            size: 20,
            page: 1,
            dialog:false,
            type: 1,       // 1 添加  2 修改
            row: {
                name: '',
            },
        }
    },
    methods:{
        getList(){
            let params = {
                page: this.page
            }
            brand_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }else{
                    this.$message.error(res.msg)
                }
            }).catch( () => {
                this.tableLoad = false;
            })
        },


        loadData(page) {
            this.page = page 
            this.getList()
        },

        //  显示弹窗
        showDialog(type, row) {
            this.type = type
            if(type == 2) {
                this.row = row
            }
            this.dialog = true
        },

       

        add(){
            let params = {
                name: this.row.name,
            }

            if( !this.validate(params)) {
                this.$message.error('请输入品牌名称')
                return false
            }

             brand_add(params).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.dialog = false
                    this.getList()
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        del(id){
            brand_del(id).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.getList();
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        edit(){

            let params = {
                name: this.row.name,
            }
            
            if( !this.validate(params)) {
                this.$message.error('请输入品牌名称')
                return false
            }

           brand_put(this.row.id,params).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.dialog = false
                    this.getList();
                }else{
                    this.dialog = false
                    this.$message.error(res.msg)     
                }
            })
        },


        resetData() {
            this.row = { name: '' }
        }
    },
    mounted(){
        this.getList()
    },
    activated() {
        this.getList()
    },
}
</script>
<style lang="less" scoped>
.dialog {
    .m-bottom {
        margin-bottom: 5px;
    }
    .dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .upload-box {
            width: 50%;
            margin-top: 15px;
            display: flex;
            align-items: flex-start;
        }
    }
}
</style>


